<template>
    <!-- <popup ref="menuFromPopupRef" async :clickModalClose="false" :title="`${modular === 'add' ? '新增' : '编辑'}子菜单`"
        @confirm="handleRules">
        <OaMenuForm ref="menuFormEditRef" modular="secondary" :menuForm="form"></OaMenuForm>
        <template #trigger>
            <slot></slot>
        </template>
</popup> -->
<div>
    <div v-if="modular=='add'">
        <el-dialog title="新增子菜单" :visible.sync="dialogVisible" width="50%"   @close="close">
            <div>
                <OaMenuForm ref="menuFormEditRef" modular="secondary" :menuForm="form"></OaMenuForm>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="close">取 消</el-button>
                <el-button type="primary" @click="confirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
    <div v-if="modular=='edit'">
        <el-dialog title="编辑子菜单" :visible.sync="dialogVisible" width="50%" @close="close">
            <div>
                <OaMenuForm ref="menuFormEditRef" modular="secondary" :menuForm.sync="form1"></OaMenuForm>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="close">取 消</el-button>
                <el-button type="primary" @click="confirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</div>
   

</template>
<script>
import OaMenuForm from './oa-menu-form'
export default {
    components: {
        OaMenuForm
    },
    data() {
        return {
            form: {
                name: '',
                type: 'view',
                url: '',
                appid: '',
                pagepath: ''
            },
        }
    },
    props: {

        modular: {
            type: String,
            default: 'add'

        },
        dialogVisible:{
            type: Boolean,
            default: false
        },
        form1: {
            type: Object,
            default: () => ({})
        }
    },
    watch: {
        form1() {
            this.init()
        },
    },
    methods:{
        init(){
            console.log('编辑数据')
            this.form = this.form1
        },
        confirm(){
            if(this.modular === 'edit'){
                this.edit()
            }else{
                this.add()
            }
            
        },
        add(){
            this.$emit('add', this.form)

        },
        edit(){
            this.$emit('edit', this.form1)
        },
        close(){
            this.$emit('close')
        }
    }
}
// import oaMenuForm from './oa-menu-form.vue'

// const emit = defineEmits<{
//     (event: 'add', value: any): void
//     (event: 'edit', value: any): void
// }>()

// const props = withDefaults(
//     defineProps<{
//         modular: string
//         subItem?: any
//     }>(),
//     {
//         modular: 'edit',
//         subItem: {}
//     }
// )

// const menuFormEditRef = shallowRef()
// const menuFromPopupRef = shallowRef()

// const form = {
//     name: '',
//     type: 'view',
//     url: '',
//     appid: '',
//     pagepath: ''
// }

// watchEffect(() => {
//     if (Object.keys(props.subItem).length != 0) {
//         for (const key in form) {
//             //@ts-ignore
//             form[key] = props.subItem[key]
//         }
//     }
// })

// const handleRules = async () => {
//     await menuFormEditRef.value.menuFormRef.validate()
//     if (props.modular === 'edit') {
//         emit('edit', { ...form })
//     } else {
//         emit('add', { ...form })
//     }
//     menuFromPopupRef.value.close()
//     menuFormEditRef.value.menuFormRef.resetFields()
// }
</script>
<style lang="scss">
.flex {
    display: flex;
}

.items-center {
    align-items: center;
}

.justify-center {
    justify-content: center;
}

.flex-1 {
    flex: 1 1 0%；
}

.text-sm {
    font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/views/appsetting/appmp/menu_com/oa-menu-form-edit.vue